import {Injectable} from '@angular/core';
import {MatPaginatorIntl} from '@angular/material/paginator';
import {Subject} from 'rxjs';

@Injectable()
export class MyCustomPaginatorIntl implements MatPaginatorIntl {
  changes = new Subject<void>();

  firstPageLabel = 'პირველი გვერდი';
  itemsPerPageLabel = 'ჩანაწერი ერთ გვერდზე:';
  lastPageLabel = 'ბოლო გვერდი';

  nextPageLabel = 'შემდეგი გვერდი';
  previousPageLabel = 'წინა გვერდი';

  getRangeLabel(page: number, pageSize: number, length: number): string {
    if (length === 0) {
      return `გვერდი 1 of 1`;
    }
    const amountPages = Math.ceil(length / pageSize);
    return `გვერდი ${page + 1} of ${amountPages}`;
  }
}
